"use client";
import { Box, BoxProps } from "@mui/material";
import React, { ReactNode, memo, useEffect, useRef, useState } from "react";
import { CommonUtils } from "@/utils";

const AppTablePageLayout = ({
  children,
  headerFilter,
  boxPropsSx,
  ...otherProps
}: AppTablePageLayoutProps) => {
  const isFunctionChild = typeof children === "function";
  useEffect(() => {
    window.addEventListener("resize", CommonUtils.handleConfigHeightOfTable);
    CommonUtils.handleConfigHeightOfTable();

    return () =>
      window.removeEventListener(
        "resize",
        CommonUtils.handleConfigHeightOfTable
      );
  }, []);
  const ref = useRef(null);
  const [height, setHeight] = useState<number>(0);
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        entry.target === ref.current && setHeight(entry.contentRect.height);
      }
    });
    ref.current && resizeObserver.observe(ref.current);
    return () => {
      ref.current && resizeObserver.unobserve(ref.current);
    };
  }, []);

  return (
    <Box pt={2} {...otherProps}>
      {headerFilter && (
        <Box ref={ref} pb={2} mx={3} sx={{ ...boxPropsSx }}>
          {headerFilter}
        </Box>
      )}
      {isFunctionChild ? children(height) : children}
    </Box>
  );
};

type AppTablePageLayoutProps = Omit<BoxProps, "children"> & {
  children: ((height?: number) => React.ReactNode) | React.ReactNode;
  headerFilter?: ReactNode;
  boxPropsSx?: BoxProps;
};

export default memo(AppTablePageLayout);
